import type { PortalUserSubscriptionTier } from 'src/features/manage-clients/users/types/users.types';

export type ActivityEventCategory =
  | 'generation'
  | 'edit'
  | 'download'
  | 'failure'
  | 'setup';

export interface UserJourneyFlag {
  code: string;
  label: string;
}

export interface UserJourneyMetrics {
  sessions: number;
  generations: number;
  downloads: number;
  generations_per_download: number | null;
}

export interface UserJourneySessionEventSummary {
  event_type: string;
  count?: number;
}

export interface UserJourneySession {
  session_index: number;
  started_at: string;
  duration_seconds: number;
  event_count: number;
  events: UserJourneySessionEventSummary[];
  summary: string;
  is_abandoned: boolean;
}

export interface UserJourney {
  id: string;
  name: string;
  workspace_name: string | null;
  tier: PortalUserSubscriptionTier;
  joined_at: string;
  flags: UserJourneyFlag[];
  metrics: UserJourneyMetrics;
  sessions: UserJourneySession[];
}

export interface UserJourneySessionEvent {
  id: string;
  event_type: string;
  category: ActivityEventCategory;
  occurred_at: string;
  outcome: string | null;
  thumbnail_url: string | null;
}

export interface UserJourneySessionDetail {
  session_index: number;
  events: UserJourneySessionEvent[];
}

export const HIGH_GENERATIONS_PER_DOWNLOAD_FLAG = 'high_generations_per_download';
